<script>

import sweet2 from 'sweetalert2'

export default {
  name: 'Notification',
  methods: {
    success(title) {
      const Toast = sweet2.mixin({
        toast: true,
        position: 'bottom',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: false,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'success',
        title: title
      })

    },
    warning(title) {
      const Toast = sweet2.mixin({
        toast: true,
        position: 'bottom',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: false,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'warning',
        title: title
      })
    },
    confirm(title, text) {
      return new Promise((resolve, reject) => {
        sweet2.fire({
          icon: 'warning',
          text: text,
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#e3342f',
        }).then((result) => {
          if (result.isConfirmed) {
            resolve('confirmed');
          } else {
            reject('canceled');
          }
        })
      });
    }
  },
  mounted() {}
}

</script>
